import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import T from 'prop-types';

import UserReportForm from '../../../../components/UserReportForm';
import { createReport, scrollTo } from '../utils';
import { portalNode } from '../config';

const ContactForm = ({
  company,
  sitekey,
  onReset,
  sharedByReportId,
}) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});


  const handleRedirect = (data) => {
    const shareUrl = data.report_share_url;
    const requestUrl = `/pdf_reports/${data.watchlist_id}/share`;
    window.location.assign(`${window.location.origin}/thank-you-report?request_url=${requestUrl}&share_url=${shareUrl}`);
  };


  const handleSubmit = (token, formParams, errorsPresent) => {
    if (errorsPresent) {
      setIsSubmitting(false);
      return;
    }

    setErrors({});

    createReport({
      token,
      ...formParams,
      financial_report_id: company.id,
      shared_by_report_id: sharedByReportId,
    })
      .then(({ data }) => {
        handleRedirect(data);
        setIsSubmitting(false);
        setShowSuccess(true);
        scrollTo();
      })
      .catch(({ response }) => {
        setIsSubmitting(false);

        if (response.status === 422 || response.status === 500) {
          setErrors({ isBadRequest: true });
        }
        if (response.status === 403) {
          const { email_error } = response.data;
          setErrors({ email: email_error || '' });
        }
      });
  };

  const handleStepBack = () => {
    if (isSubmitting) return;
    onReset();
  };

  return createPortal((
    <div className="finance-free-report-form">
      <div className="finance-free-report-form-content">
        {!showSuccess && !errors.isBadRequest && (
          <UserReportForm
            onSubmitClick={handleSubmit}
            onStepBack={handleStepBack}
            isSubmitting={isSubmitting}
            sitekey={sitekey}
            submitStarted={() => setIsSubmitting(true)}
            customErrors={errors}
            title="Enter your email to receive your report"
          />
        )}
        {errors.isBadRequest && (
          <div className="finance-free-report-form-content-failure">
            <h2 className="text-16 text-red"><span className="text-uppercase">Oops!</span> <br /> Something went wrong</h2>
            <div className="content-failure-img" />
            <div className="text-center text-black">Please, try again later.</div>
          </div>
        )}
      </div>
    </div>
  ), portalNode);
};

ContactForm.propTypes = {
  onReset: T.func.isRequired,
  sitekey: T.string.isRequired,
  company: T.shape({
    id: T.number,
  }).isRequired,
  sharedByReportId: T.oneOfType([T.bool, T.number]),
};

export default ContactForm;
